import {
  FormControlLabel,
  Grid,
  Switch,
  Box,
  DialogContent,
  DialogActions,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import GenericTextField from "../../components/GenericTextField";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import styles from "./styles.module.css";
import CustomTabPanel from "../../components/CustomTabPanel";
import { useState } from "react";
import TabelaDinamicaPermissoes from "../../components/TabelaDinamicaPermissao";

const GruposUsuariosFormSchema = z
  .object({
    idGrupoUsuario: z.number().readonly(),
    descricao: z.string().min(1, {
      message: "Descrição é obrigatória",
    }),
    ativo: z.boolean(),
  })
  .partial({
    idGrupoUsuario: true
  })
  .required({
    descricao: true,
  })

type GruposUsuariosFormData = z.infer<typeof GruposUsuariosFormSchema>;

type GruposUsuariosFormProps = {
  userValues: GruposUsuariosFormData;
  userPermissionData: any;
  userPermissionValues: any;
  loading: boolean;
  onSubmit(data: GruposUsuariosFormData): void;
  onClose(event: any): void;
};

export default function GruposUsuariosForm({
  userValues,
  userPermissionData,
  userPermissionValues,
  onSubmit,
  onClose,
}: GruposUsuariosFormProps) {
  const [activeTab, setActiveTab] = useState(0);

  const columnsPermissoes = [
    { id: "menu", label: "Menu", field: null },
    { id: "pode_inserir", label: "Pode inserir", field: "PODE_INSERIR" },
    { id: "atualizar", label: "Atualizar", field: "PODE_EDITAR" },
    { id: "selecionar", label: "Selecionar", field: "PODE_SELECIONAR" },
    { id: "excluir", label: "Excluir", field: "PODE_EXCLUIR" },
    { id: "todos", label: "Todos", field: null },
  ];

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<GruposUsuariosFormData>({
    mode: "onChange",
    resolver: zodResolver(GruposUsuariosFormSchema),
    defaultValues: {
      idGrupoUsuario: userValues.idGrupoUsuario || undefined,
      descricao: userValues.descricao || "",
      ativo: userValues.ativo || false
    },
  });

  function setupTab(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleTabChange = (_: any, newValue: any) => {
    setActiveTab(newValue);
  };

  const handleCloseForm = (event: any) => {
    onClose(event);
  };

  const handlePermsChange = (newSubmenuPerms: any) => {
    const subMenuPermsIndex = userPermissionValues.findIndex(
      (perm: any) => perm.idMenu === newSubmenuPerms.idMenu
    );


    if (
      subMenuPermsIndex !== -1 &&
      newSubmenuPerms.funcionalidades.length === 0
    ) {
      userPermissionValues.splice(subMenuPermsIndex, 1);
    } else if (subMenuPermsIndex !== -1) {
      userPermissionValues[subMenuPermsIndex] = { ...newSubmenuPerms };
    } else if (newSubmenuPerms.funcionalidades.length > 0) {
      userPermissionValues.push({ ...newSubmenuPerms });
    }
  };


  const submit = (data: GruposUsuariosFormData) => {
    const body: any = {
      usuario: {
        descricao: data.descricao,
        ativo: data.ativo,
      },
      permissoes: userPermissionValues,
    };

    onSubmit(body);
  };

  return (
    <form onSubmit={handleSubmit(submit)} className={styles.formDiv}>
      <DialogContent className={styles.formContainer}>
        <Box className={styles.formContent}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab label="Dados Básicos" {...setupTab(0)} />
              <Tab label="Permissões" {...setupTab(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={activeTab} index={0}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <Controller
                  name="idGrupoUsuario"
                  control={control}
                  defaultValue={userValues.idGrupoUsuario}
                  render={({ field: { ref, ...field } }) => (
                    <GenericTextField
                      disabled
                      label="ID"
                      error={Boolean(errors.idGrupoUsuario)}
                      helperText={errors.idGrupoUsuario?.message}
                      placeholder={"Novo Grupo"}
                      inputRef={ref}
                      {...field}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={9}>
                <Controller
                  name="descricao"
                  control={control}
                  defaultValue={userValues.descricao}
                  render={({ field: { ref, ...field } }) => (
                    <GenericTextField
                      required
                      label="Descrição"
                      placeholder="Digite a descrição"
                      error={Boolean(errors.descricao)}
                      helperText={errors.descricao?.message}
                      inputRef={ref}
                      {...field}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="ativo"
                  control={control}
                  defaultValue={userValues.ativo}
                  render={({ field: { ref, ...field } }) => (
                    <FormControlLabel
                      control={<Switch color="primary" />}
                      label="Ativo"
                      labelPlacement="start"
                      checked={field.value}
                      sx={{
                        margin: 0,
                      }}
                      inputRef={ref}
                      {...field}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </CustomTabPanel>
          <CustomTabPanel
            value={activeTab}
            index={1}
            className={styles.tabelaPermissoes}
          >
            <TabelaDinamicaPermissoes
              data={userPermissionData}
              columns={columnsPermissoes}
              values={userPermissionValues}
              // loading={loading}
              handleChangeCallback={handlePermsChange}
            />
          </CustomTabPanel>
        </Box>
        <Box>
          <DialogActions className={styles.botoesPopupGeral}>
            <Button
              className={styles.botaoPopupCancelar}
              onClick={handleCloseForm}
              size="small"
            >
              Cancelar
            </Button>
            <Button
              className={styles.botaoPopupSalvar}
              type="submit"
              color="primary"
              size="small"
            >
              Salvar
            </Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </form>
  );
}
